import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const HomePage =()=> import('@/components/HomePage');
const Partners = () => import('@/components/Partners');
const FeiHan = () => import('@/components/FeiHan');
const hotel = () => import('@/components/hotel');
const wenBo = () => import('@/components/wenBo');
const wenTi = () => import('@/components/wenTi');
const firm = () => import('@/components/firm');
const aboutUs = () => import('@/components/aboutUs');
const VR = () => import('@/components/VR');
const enterprse =()=> import('@/components/enterprse');
const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/Partners',
    name: 'Partners',
    component: Partners,
    meta: { parents:"资源中心"}
  },
  {
    path: '/FeiHan',
    name: 'FeiHan',
    component: FeiHan,
    meta: { parents:"公司产品"}
  },
  {
    path: '/hotel',
    name: 'hotel',
    component: hotel,
    meta: { parents:"解决方案"}
  },
  {
    path: '/wenBo',
    name: 'wenBo',
    component: wenBo,
    meta: { parents:"解决方案"}
  },
  {
    path: '/wenTi',
    name: 'wenTi',
    component: wenTi,
    meta: { parents:"解决方案"}
  },
  {
    path: '/firm',
    name: 'firm',
    component: firm,
    meta: { parents:"解决方案"}
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: aboutUs,
    meta: { parents:"关于我们"}
  },
  {
    path: '/VR',
    name: 'VR',
    component: VR,
    meta: { parents:"公司产品"}
  },
  {
    path: '/enterprse',
    name: 'enterprse',
    component: enterprse,
    meta: { parents:"公司产品"}
  }
]

export default new Router({
  mode: "history",
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js